import "../css/abonament-lp.scss";
import "../css/variables.scss";
import "inputmask.numeric.extensions";
import "jquery.inputmask";
import Utils from "./utils";

let $areaVerifyModal;

function windowWidthCheck() {
    if ($(window).width() >= 1025) {
        $(".pepper-img").show();
    }
    else {
        $(".pepper-img").hide();
    }
}

function validatePostalCode(code) {
    $('.main-page-button').hide();
    $('.unavailable').hide();
    $('.empty').hide();

    let postalCode = code.val();
    let postalCodeToCheck = postalCode.substring(0, 2);

    let regExOne = /^[0-9]{2}$/;
    let regExTotal = /^[0-9]{2}-[0-9]{3}$/;

    if (!regExTotal.test(postalCode)) {
        $('.empty').show();
    }
    else if (regExOne.test(postalCodeToCheck)) {
        if (postalCodeToCheck === '00' || postalCodeToCheck === '01' || postalCodeToCheck === '02' || postalCodeToCheck === '03' || postalCodeToCheck === '04') {
            $areaVerifyModal.hide();
            window.location.href = $areaVerifyModal.find('.validate-button').attr('data-href');
        }
        else {
            $('.unavailable').show();
            $('.validate-button').hide();
            $('.main-page-button').css('display', 'inline-block');
        }
    }
}

let video = $("#movie")[0];
let playpause = $("#playpause");

function togglePlayPause() {
    if (video.paused || video.ended) {
        playpause.attr('title', 'pause');
        playpause.html = "pause";
        playpause.fadeOut();
        video.play();
    }
    else {
        playpause.attr('title', 'play');
        playpause.html = "play";
        playpause.fadeIn();
        video.pause();
    }
}

function toggleOpacity() {
    let attr = playpause.attr('title');
    if (attr == 'play') {
        $("#movie").css('opacity', '0.5');
    }
    else {
        $("#movie").css('opacity', '1');
    }
}

function loadAgain() {
    video.load();
}


$(document).on('ready', function () {
    $areaVerifyModal = $('#areaVerifyModal');

    windowWidthCheck();

    $(window).on('resize', function () {
        windowWidthCheck();
    });

    Utils.maskZipCode("billing_postcode");

    $('#areaVerifyModal button').on('click', function (e) {
        validatePostalCode($('#billing_postcode'));
        // $(window).scrollTop(0);
    });

    // submit on enter click
    $areaVerifyModal.keypress(function (e) {
        if (e.which == 13) {
            $('#areaVerifyModal button').click();
        }
    });

    $(window).on('click', function (e) {
        if (e.target == $areaVerifyModal[0]) {
            $areaVerifyModal.hide();
        }
    });

    video.controls = false;

    playpause.click(function () {
        togglePlayPause();
        toggleOpacity()
    });

    $('#movie').click(function () {
        togglePlayPause();
        toggleOpacity()
    });

    video.addEventListener('ended', loadAgain, false);

    // add polecane sign
    $('.option-box:eq(2)').prepend('<span class="recommended-box"><span class="recommended-sign">POLECANE!</span></span>');
    $('.option-box-wrapper:eq(2)').removeClass('option-container').addClass('option-box-red');
    $areaVerifyModal.on('click', '.close', function (ev) {
        ev.preventDefault();
        $areaVerifyModal.hide();
    });
    $(".select-abonament-qty[data-qty=5]").on('click', function (ev) {
        ev.preventDefault();
        $areaVerifyModal.show().find('.validate-button').attr('data-href', ev.currentTarget.href);
    });
});




// WEBPACK FOOTER //
// ./assets/js/abonament-lp.js